<div *ngIf="metricData$ | async as metrics" class="container">
  <div *ngFor="let queue of queues$ | async">
    <div *ngIf="metrics | metricData : queue as metric" class="tile">
      <trccp-metric [id]="queue.id" [data]="metric"></trccp-metric>
    </div>
  </div>
</div>
